import { render, staticRenderFns } from "./wxReviseshenhe.vue?vue&type=template&id=7fa97515&scoped=true"
import script from "./wxReviseshenhe.vue?vue&type=script&lang=js"
export * from "./wxReviseshenhe.vue?vue&type=script&lang=js"
import style0 from "./wxReviseshenhe.vue?vue&type=style&index=0&id=7fa97515&prod&scoped=true&lang=css"
import style1 from "./wxReviseshenhe.vue?vue&type=style&index=1&id=7fa97515&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa97515",
  null
  
)

export default component.exports